module.exports = __webpack_public_path__ + "img/trial1-3.bf4a8986.png";